var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.tip)?_c('svg',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"icon h-4 w-4 mr-2 inline",attrs:{"content":_vm.tip}},[_c('use',{attrs:{"xlink:href":"/icons/sprite.svg#info-circle-fill"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }